import Cookies from "js-cookie";

export const storeVWOSubscriptionStatus = (status, plan, annual) => {
  Cookies.set("vwo_subscription_status", status);
  Cookies.set("vwo_subscription_name", plan);
  Cookies.set("vwo_subscription_annual", annual);
};

export const storeVWOCheckoutAccess = () => {
  Cookies.set("vwo_checkout_visited", true);
};
